export const ProjectRole = {
    ProjectOwner: 'ProjectOwner',
    ProjectContributor: 'ProjectContributor',
    ProjectValidator: 'ProjectValidator',
    ProjectViewer: 'ProjectViewer'
} as const;

export type ProjectRoleType = keyof typeof ProjectRole;

export const SystemRole = {
    Administrator: 'Administrator',
    User: 'User'
} as const;

export type SystemRoleType = keyof typeof SystemRole;

  // Role options
  // Derive role options from the authoritative `ProjectRole` object and
  // convert the PascalCase keys into human-readable labels via `pascalToHuman`.
export const iconMap: Record<ProjectRoleType, string> = {
    ProjectOwner: 'fa-solid fa-crown',
    ProjectContributor: 'fa-solid fa-user-edit',
    ProjectViewer: 'fa-solid fa-eye',
    ProjectValidator: 'fa-solid fa-check-circle',
};